import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import HeroCard from '../../../HeroCard';
import icArrowRight from 'assets/svg/ic_arrow_right_V2.svg';
import PageContent from 'src/Components/PageContent';
import ErrorView from 'src/Components/ErrorViewV2';
import { ErrorViewType } from 'src/Components/ErrorViewV2/config';
import { Breakpoint, useBreakpoint } from 'src/utils/breakpoints';
import { navigateToHeroDetail } from 'src/utils/navigate';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { fetchHeroesListed } from 'src/redux/actions';
import { AppError } from 'src/redux/types';
import { Link } from 'react-router-dom';
import { RouteName } from 'src/routes/config';
import { SearchParamsSortOption } from 'src/models';
import { MarketPlaceTab } from 'src/Pages/MarketplaceV2/Components/MarketTab/configs';
import EmptyListV2 from 'src/Components/EmptyListV2';
import ItemCardPlaceholder from 'src/Pages/HomePage/Components/ItemCardPlaceholder';

const HeroListTab = ({
  className
}) => {
  const breakpoint = useBreakpoint();
  const dispatch = useTypedDispatch();
  const {
    data,
    loading,
    invalidated,
    error
  } = useTypedSelector(state => state.heroesListed);
  const invalidatedHeroesListed = invalidated && !data;
  const itemPerPage = React.useMemo(() => {
    switch (breakpoint) {
      case Breakpoint.PHONE:
        return 8;

      case Breakpoint.TABLET:
        return 9;

      default:
        return 10;
    }
  }, [breakpoint]);
  const {
    listItem
  } = data || {};
  const onFetch = React.useCallback(size => {
    dispatch(fetchHeroesListed(size));
  }, [dispatch]);

  const renderLoading = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.container, className)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.list
    }, Array(itemPerPage).fill(0).map((_, index) => /*#__PURE__*/React.createElement(ItemCardPlaceholder, {
      key: index,
      className: styles.item
    }))), /*#__PURE__*/React.createElement("div", {
      className: styles.btnViewListed
    }, /*#__PURE__*/React.createElement("span", null, "View more recently listed "), /*#__PURE__*/React.createElement("img", {
      src: icArrowRight,
      className: styles.icArrow
    })));
  };

  React.useEffect(() => {
    onFetch(itemPerPage);
  }, [itemPerPage, onFetch]);
  React.useEffect(() => {
    let timeout;

    if (data !== null && data !== void 0 && data.timeout) {
      timeout = setTimeout(() => {
        onFetch(itemPerPage);
      }, data.timeout * 1000);
    }

    return () => {
      clearInterval(timeout);
    };
  }, [data, dispatch, itemPerPage, onFetch]);

  const renderError = () => /*#__PURE__*/React.createElement(ErrorView, {
    config: {
      title: 'Sorry, something went wrong.',
      content: 'Please try again.',
      type: ErrorViewType.Custom
    },
    className: styles.empty
  });

  const renderContent = () => {
    if (!listItem) {
      return null;
    }

    if (listItem.length <= 0) {
      return /*#__PURE__*/React.createElement(EmptyListV2, null);
    }

    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.container, className)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.list
    }, listItem.map(e => /*#__PURE__*/React.createElement(HeroCard, {
      className: styles.item,
      hero: e,
      key: `${e.id}${e.timestamp}`,
      onPress: () => {
        navigateToHeroDetail(e.refId, {
          isFromHome: true
        });
      }
    }))), /*#__PURE__*/React.createElement(Link, {
      to: `${RouteName.MarketPlace}?batPercentMin=0&page=1&sort=${SearchParamsSortOption.LATEST}&tab=${MarketPlaceTab.HEROES}`,
      className: styles.btnViewListed
    }, /*#__PURE__*/React.createElement("span", null, "View more recently listed "), /*#__PURE__*/React.createElement("img", {
      src: icArrowRight,
      className: styles.icArrow
    })));
  };

  return /*#__PURE__*/React.createElement(PageContent, {
    invalidated: invalidatedHeroesListed,
    loading: loading,
    error: error != AppError.NO_ERROR,
    renderContent: renderContent,
    renderLoading: renderLoading,
    renderError: renderError
  });
};

export default HeroListTab;